import type { VNode } from 'preact';
import { ToolCallCard } from './ToolCallCard';
import type { ToolRendererProps } from '../types';

/**
 * Main tool renderer component
 * Renders tool call information with proper formatting and status indication
 */
export function ToolRenderer({ toolCall, className = '', showButtons = false, onToolUpdate, threadId, teamId, messageId, connectorIcon, connectorName }: ToolRendererProps): VNode<Record<string, never>> {
  console.log('ToolRenderer Debug:', { toolCall, className, showButtons });
  return (
    <ToolCallCard
      toolCall={toolCall}
      className={`tool-renderer ${className}`}
      showButtons={showButtons}
      onToolUpdate={onToolUpdate}
      threadId={threadId}
      teamId={teamId}
      messageId={messageId}
      connectorIcon={connectorIcon}
      connectorName={connectorName}
    />
  );
}